import { IsNotEmpty, IsOptional, IsString, IsInt } from "class-validator";

export class ShowRunTimeSlotDto {
  @IsNotEmpty()
  time_slot: string;

  @IsNotEmpty()
  @IsInt()
  num_available: number;

  @IsOptional()
  note?: string;

  /**
   * Scopes the slot to a specific class level for per-class timeslot shows
   * (Obedience Show N Go, Rally Show N Go). Absent for show-wide slots.
   */
  @IsOptional()
  @IsString()
  level?: string;
}
